import { PriorityFlag, Category, AppConfig } from '@/types';

// Configuration de l'application
export const APP_CONFIG: AppConfig = {
  maxFileSize: 10 * 1024 * 1024, // 10MB
  maxFilesCount: 5,
  allowedFileTypes: [
    'image/jpeg',
    'image/png',
    'image/gif',
    'application/pdf',
    'text/plain',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ],
  maxTitleLength: 200,
  maxContentLength: 10000,
  maxTagsCount: 10,
  batchSize: 10,
  rateLimitDelay: 1000
};

// Drapeaux de priorité
export const PRIORITY_FLAGS: PriorityFlag[] = [
  { id: 'low', label: 'Faible', color: '#4CAF50', icon: 'low_priority' },
  { id: 'normal', label: 'Normale', color: '#2196F3', icon: 'priority_high' },
  { id: 'high', label: 'Élevée', color: '#FF9800', icon: 'priority_high' },
  { id: 'urgent', label: 'Urgente', color: '#F44336', icon: 'emergency' }
];

// Catégories prédéfinies
export const FORUM_CATEGORIES: Category[] = [
  { id: 'announcement', label: 'Annonce', color: '#2196F3' },
  { id: 'bug', label: 'Bug', color: '#F44336' },
  { id: 'feature', label: 'Fonctionnalité', color: '#4CAF50' },
  { id: 'maintenance', label: 'Maintenance', color: '#FF9800' },
  { id: 'update', label: 'Mise à jour', color: '#9C27B0' },
  { id: 'general', label: 'Général', color: '#607D8B' }
];

// Endpoints Zoho API
export const ZOHO_ENDPOINTS = {
  AUTH: 'https://accounts.zoho.com/oauth/v2/auth',
  TOKEN: 'https://accounts.zoho.com/oauth/v2/token',
  FORUMS: 'https://forums.zoho.com/api/v1/forums',
  TOPICS: 'https://forums.zoho.com/api/v1/topics',
  CATEGORIES: 'https://forums.zoho.com/api/v1/categories',
  USERS: 'https://forums.zoho.com/api/v1/users',
  CONTACTS: 'https://forums.zoho.com/api/v1/contacts',
  ATTACHMENTS: 'https://forums.zoho.com/api/v1/attachments'
};

// Scopes Zoho requis
export const ZOHO_SCOPES = [
  'ZohoProjects.projects.ALL',
  'ZohoProjects.users.ALL',
  'ZohoProjects.portals.ALL',
  'ZohoProjects.forums.ALL',
  'ZohoProjects.forums.CREATE',
  'ZohoProjects.clients.READ'
];

// Clés de stockage local
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'zoho_auth_token',
  REFRESH_TOKEN: 'zoho_refresh_token',
  USER_DATA: 'zoho_user_data',
  FORUM_CONTACTS: 'forum_contacts_config',
  MESSAGE_DRAFTS: 'message_drafts',
  SENT_HISTORY: 'sent_history',
  APP_SETTINGS: 'app_settings'
};

// Messages d'erreur
export const ERROR_MESSAGES = {
  AUTH_FAILED: 'Échec de l\'authentification Zoho',
  API_ERROR: 'Erreur lors de la communication avec Zoho',
  FILE_TOO_LARGE: 'Le fichier est trop volumineux (max 10MB)',
  TOO_MANY_FILES: 'Trop de fichiers sélectionnés (max 5)',
  INVALID_FILE_TYPE: 'Type de fichier non supporté',
  NETWORK_ERROR: 'Erreur de connexion réseau',
  RATE_LIMIT: 'Limite de requêtes atteinte, veuillez patienter',
  FORUM_NOT_FOUND: 'Forum introuvable',
  CONTACT_NOT_FOUND: 'Contact introuvable'
};

// Configuration du thème Material-UI
export const THEME_CONFIG = {
  palette: {
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0'
    },
    secondary: {
      main: '#dc004e',
      light: '#ff5983',
      dark: '#9a0036'
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff'
    }
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600
    }
  },
  spacing: 8
}; 